import { darkColors, lightColors } from '@tryhackme/thm-ui-components';
import { css } from 'styled-components';
import 'prismjs';
import 'prismjs/components/prism-bash';
import 'prismjs/components/prism-markup';
import 'prismjs/components/prism-css';
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';
import 'prismjs/components/prism-c';
import 'prismjs/components/prism-csharp';
import 'prismjs/components/prism-cpp';
import 'prismjs/components/prism-csv';
import 'prismjs/components/prism-docker';
import 'prismjs/components/prism-git';
import 'prismjs/components/prism-go';
import 'prismjs/components/prism-haskell';
import 'prismjs/components/prism-http';
import 'prismjs/components/prism-java';
import 'prismjs/components/prism-lua';
import 'prismjs/components/prism-makefile';
import 'prismjs/components/prism-markdown';
import 'prismjs/components/prism-markup-templating';
import 'prismjs/components/prism-nginx';
import 'prismjs/components/prism-objectivec';
import 'prismjs/components/prism-perl';
import 'prismjs/components/prism-php';
import 'prismjs/components/prism-powerquery';
import 'prismjs/components/prism-powershell';
import 'prismjs/components/prism-python';
import 'prismjs/components/prism-ruby';
import 'prismjs/components/prism-shell-session';
import 'prismjs/components/prism-sql';
import 'prismjs/components/prism-yaml';
import 'prismjs/themes/prism-okaidia.css';

export const CommonPrismContentCodeStyle = css<{ $isDark: boolean }>`
  code:not([class*='language-']) {
    background-color: ${({ $isDark }) => ($isDark ? darkColors.background.lightest : lightColors.secondary.light)};
    color: #fff;
    padding: 0.5rem;
    display: inline;
    white-space: normal;
    border-radius: 0.3rem !important;
    margin-bottom: 0.2rem;
    font-family: SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace !important;
    font-size: 1.4rem;
  }

  pre[class*='language-'] {
    border-radius: 0;
  }
`;
